import React, { useEffect, useState } from "react";
import PracticeLayout from "../Layout";
import { useParams } from "react-router-dom";
import StudentCategoryCard from "../Components/StudentCategoryCard";
import {
  useCreateRazorpayOrderMutation,
  useGetCourseForStudentsQuery,
  useGetCourseQuery,
  useGetStudentByEmailIdQuery,
  useSavePaymentDetailsMutation,
} from "../../../graphql/generated.tsx";
import StudentLayout from "../../Student/Layout/index.jsx";
import Loader from "../../../components/Loader";
import { FaRegClock, FaSignal } from "react-icons/fa6";
import { RiQuestionAnswerFill } from "react-icons/ri";
import RecommendedCourseCards from "../Components/RecommendedCourseCards.jsx";
import { Modal, Button as FlowbiteButton } from "flowbite-react";
import { handlePayment } from "../../../utils/paymentHelper.js";
import { useRazorpay } from "react-razorpay";
import { toast } from "../../../toast";
import NetworkIndicator from "../Components/NetworkIndicator.jsx";

const PAID_CLUSTER_ID = "56eed915-cb4f-4bf6-ae18-18a1ad18f281";

const StudentCourseDetails = () => {
  const [courseData, setCourseData] = useState(null);
  
  const { courseId, clusterid } = useParams();
  const [Isload, setIsload] = useState(true);
  const email = JSON.parse(localStorage.getItem("user"))?.email;
  const { data: courseDetailsWithQuestions, loading } =
    useGetCourseForStudentsQuery({ variables: { id: courseId } });

  const [isRecommendedEmpty, setIsRecommendedEmpty] = useState(false);
  const { data: studentData } = useGetStudentByEmailIdQuery({
    variables: { email },
  });


  const purchasedCourses =
    studentData?.getStudentByEmailId?.purchasedCourses || [];

  useEffect(() => {
    setCourseData(courseDetailsWithQuestions?.getCourseForStudents);
  }, [courseDetailsWithQuestions]);

  const isPaidCourse = clusterid === PAID_CLUSTER_ID;
  const isCoursePurchased = purchasedCourses.some(
    (course) => course.course_id === courseId && course.cluster_id === clusterid
  );

  const [savePaymentDetails] = useSavePaymentDetailsMutation();

  const handlePaymentSuccess = async (response) => {
    try {
      const result = await savePaymentDetails({
        variables: {
          createPaymentInput: {
            course_id: courseId,
            cluster_id: clusterid,
            order_id: response.razorpay_order_id,
            payment_id: response.razorpay_payment_id,
            student_id: studentData?.getStudentByEmailId.id,
            amount_paid: courseData?.dis_price,
          },
        },
      });

      if (result?.data) {
        window.location.reload();
       
        toast.success("Payment Successful!");
      } else {
        toast.error(
          "Payment details save incomplete:",
          result.errors || result
        );
      }
    } catch (error) {
      console.error("Error saving payment details:", error);
      alert(
        "Payment was successful, but we encountered an issue while saving your payment details. Please contact support if this persists."
      );
    }
  };
 useEffect(()=>{
    setTimeout(()=>{
      setIsload(false);
    },2000);
  },[]);
  
  const handlePaymentFailure = (error) => {
    console.error("Payment Failure:", error);
    toast.error("Payment Failed.");
  };

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [createRazorpayOrder] = useCreateRazorpayOrderMutation();
  const { error, isLoading, Razorpay } = useRazorpay();

  const handlePayNow = (e) => {
    e.stopPropagation();
    handlePayment({
      courseId: courseId,
      createRazorpayOrder,
      Razorpay,
      onSuccess: handlePaymentSuccess,
      onFailure: handlePaymentFailure,
    });
    setIsModalOpen(false);
  };

  useEffect(()=>{
    window.scrollTo(0,0);
  },[]);

  if (loading || Isload) {
    return (
      <StudentLayout backgroundClass="bg-white">
        <div className="flex items-center justify-center h-screen bg-white">
          <Loader />
        </div>
      </StudentLayout>
    );
  }

  return (
    <StudentLayout backgroundClass="bg-white">
      <NetworkIndicator />
      <div className="flex flex-wrap max-md:p-6 max-md:ml-2 lg:p-4 justify-center mx-auto gap-5 w-[100%]">
        {/* Main Content */}
        <div className="w-full md:w-[70%]">
          <div className="p-2">
            <div className="relative h-[480px] flex flex-col justify-center md:h-[400px]">
              <div className="p-6 lg:rounded-xl  bg-white w-full border border-black  md:h-[80%]">
                <div className="flex flex-col justify-between gap-4 md:flex-row md:items-center md:gap-6">
                  <div className="w-full md:w-[60%]">
                    <h1 className="flex items-center gap-2 mb-2 text-lg font-bold md:text-2xl">
                      {courseData?.name}
                      {isPaidCourse && !isCoursePurchased && (
                        <span className="px-2 py-1 text-xs font-semibold text-white rounded bg-secondary">
                          Paid Course
                        </span>
                      )}
                    </h1>
                    <p className="text-sm text-slate-500 md:text-base">
                      {courseData?.short_description}
                    </p>
                    {isPaidCourse && !isCoursePurchased && (
                      <button
                        onClick={handlePayNow}
                        className="flex-1 px-4 py-2 mt-4 text-sm font-medium text-white transition duration-200 rounded-sm bg-primary hover:bg-primary-dark"
                        >
                        Purchase Now
                      </button>
                    )}
                  </div>
                  <div className="w-full p-4 bg-white border border-black rounded-xl md:w-auto">
                    <h3 className="mb-3 text-base font-semibold sm:text-lg">
                      This course includes
                    </h3>
                    <ul className="space-y-2 text-sm text-gray-800 list-inside">
                      {courseData?.benefits?.map((benefit, index) => (
                        <li key={index} className="flex items-center">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            className="w-4 h-4 mr-2 text-green-500"
                            fill="none"
                            stroke="currentColor"
                            viewBox="0 0 24 24"
                            strokeWidth="2"
                          >
                            <path
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              d="M5 13l4 4L19 7"
                            />
                          </svg>
                          {benefit}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              </div>
              <div className="shadow-md border-black absolute max-md:-bottom-3 md:-bottom-5 lg:-bottom-8 left-1/2 transform -translate-x-1/2 w-[90%] md:w-[600px] h-auto bg-white border flex flex-wrap items-center justify-around max-md:px-2 lg:px-4 lg:py-4 max-md:py-2 md:py-0 md:h-[100px]">
                <div className="flex flex-col items-center w-1/3 text-primary">
                  <FaSignal className="mb-1 text-lg md:text-xl" />
                  <p className="text-xs font-medium text-gray-500">
                    Skill level
                  </p>
                  <p className="text-sm font-bold text-gray-900">
                    {courseData?.level}
                  </p>
                </div>
                <div className="flex flex-col items-center w-1/3 text-primary">
                  <FaRegClock className="mb-1 text-lg md:text-xl" />
                  <p className="text-xs font-medium text-gray-500">Duration</p>
                  <p className="text-sm font-bold text-gray-900">
                    {courseData?.time_period} hours
                  </p>
                </div>
                <div className="flex flex-col items-center w-1/3 text-primary">
                  <RiQuestionAnswerFill className="mb-1 text-lg md:text-xl" />
                  <p className="text-xs font-medium text-gray-500">
                    Total Questions
                  </p>
                  <p className="text-sm font-bold text-gray-900">
                    {courseData?.medium_count
                      ? courseData?.medium_count +
                        courseData?.easy_count +
                        courseData?.hard_count
                      : 0}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="flex flex-col items-center justify-center w-full mx-auto mb-10">
            <div className="mt-14 rounded-md flex flex-col gap-2 w-[90%] mx-auto">
              {courseData?.categories?.length === 0 ? (
                <p className="text-center text-gray-500">
                  No Categories available
                </p>
              ) : (
                courseData?.categories?.map((cat, index) => (
                  <StudentCategoryCard
                    key={cat.id}
                    name={cat.name}
                    description={cat.description}
                    cat_id={cat.id}
                    course_id={courseId}
                    clusterid={clusterid}
                    number={index + 1}
                    categoryDetails={cat}
                    isPaidCourse={isPaidCourse}
                    isPurchasedCourse={isCoursePurchased}
                    courseData={courseData}
                  />
                ))
              )}
            </div>
          </div>
        </div>
        {/* Sidebar */}
        {!isRecommendedEmpty && (
          
                <RecommendedCourseCards
                  courseid={courseId}
                  setIsRecommendedEmpty={setIsRecommendedEmpty}
                />
          
        )}
      </div>
      <Modal show={isModalOpen} onClose={() => setIsModalOpen(false)}>
        <Modal.Header>
          <h2 className="text-lg font-bold text-gray-900">
            Unlock Your Potential with This Course
          </h2>
        </Modal.Header>
        <Modal.Body>
          <div className="space-y-6">
            {/* Course Details */}
            <div>
              <h3 className="text-lg font-semibold text-gray-800">
                Why Choose This Course?
              </h3>
              <p className="text-gray-700">{courseData?.whyChoose}</p>
            </div>

            <div className="pt-4 border-t border-gray-200">
              <h3 className="mb-3 text-lg font-bold text-gray-800">
                Payment Summary
              </h3>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-500">Price:</span>
                <span className="text-sm">₹{courseData?.dis_price}</span>
              </div>
              <div className="flex items-center justify-between mb-2">
                <span className="text-sm text-gray-500">Tax (18%) :</span>
                <span className="text-sm">₹{courseData?.dis_price * 0.18}</span>
              </div>
              <div className="flex items-center justify-between mt-4">
                <span className="text-lg font-bold text-gray-800">Total:</span>
                <span className="text-lg font-bold text-gray-800">
                  ₹{(courseData?.dis_price * 1.18).toFixed(2)}
                </span>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer className="flex flex-col items-center space-y-2">
          <FlowbiteButton
            className="w-full font-medium text-white transition duration-200 rounded-md bg-primary hover:bg-primary-dark"
            onClick={handlePayNow}
          >
            Purchase Now
          </FlowbiteButton>
          <p className="mt-2 text-xs text-center text-gray-500">
            Start learning risk-free today!
          </p>
        </Modal.Footer>
      </Modal>
    </StudentLayout>
  );
};

export default StudentCourseDetails;
